const common = {
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },

    alertError(data) {
      if (data.message === "EXPIRED_TOKEN") {
        this.alertExpiredToken();
      } else if (
        data &&
        typeof data.message === "string" &&
        data.message.split("|")[0] === "CUSTOM_ERROR"
      ) {
        this.alertCustomError(data.message.split("|")[1]);
      } else {
        this.alertStandardError(data.message);
      }
    },

    alertExpiredToken() {
      this.$buefy.dialog.alert({
        title: this.$t("mixincommon.expiredSession"),
        message: this.$t("mixincommon.loginAgain"),
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        onConfirm: () => this.$router.push("/"),
        onCancel: () => this.$router.push("/")
      });
    },

    alertCustomError(message) {
      this.$buefy.dialog.alert({
        title: this.$t("common.error"),
        message: message,
        type: "is-primary",
        hasIcon: true,
        icon: "exclamation-triangle",
        iconPack: "fa"
      });
    },

    alertStandardError(constant) {
      this.$buefy.dialog.alert({
        title: this.$t("common.error"),
        message: this.translateError(constant),
        type: "is-primary",
        hasIcon: true,
        icon: "exclamation-triangle",
        iconPack: "fa"
      });
    },

    copyContent(text, message) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$buefy.toast.open({
        message: message ? message : "Texto copiado!",
        type: "is-success"
      });
    },

    getValidSpreadsheetFile(event) {
      const input = event.target;
      const file = input.files[0];

      // O input é limpo antes de qualquer validação para que o mesmo arquivo
      // possa ser reenviado após um erro. Sem isso o change não dispara de novo
      // e o botão parece não fazer nada.
      input.value = "";

      if (!file) return null;

      const extension = file.name
        .split(".")
        .pop()
        .toLowerCase();

      if (extension !== "xls" && extension !== "xlsx") {
        this.alertError({ message: "FILE_EXTENSION_NOT_ALLOWED_XLS_XLSX" });
        return null;
      }

      if (file.size > 100000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE_100" });
        return null;
      }

      return file;
    },

    translateError(message) {
      const translations = {
        ACCOUNT_NOT_ACTIVE: this.$t("errors.ACCOUNT_NOT_ACTIVE"),
        ACTION_NOT_AUTHORIZED: this.$t("errors.ACTION_NOT_AUTHORIZED"),
        BAG_ALREADY_EXISTS: this.$t("errors.BAG_ALREADY_EXISTS"),
        BAG_NOT_FOUND: this.$t("errors.BAG_NOT_FOUND"),
        BILLET_GENERATION_FAILED: this.$t("errors.BILLET_GENERATION_FAILED"),
        CANNOT_DELETE_CATEGORY_IN_USE: this.$t(
          "errors.CANNOT_DELETE_CATEGORY_IN_USE"
        ),
        CART_CANNOT_BE_EMPTY: this.$t("errors.CART_CANNOT_BE_EMPTY"),
        CASHBACK_BEGIN_DATE_GREATER_THAN_END_DATE: this.$t(
          "errors.CASHBACK_BEGIN_DATE_GREATER_THAN_END_DATE"
        ),
        CASHBACK_END_DATE_IN_THE_PAST: this.$t(
          "errors.CASHBACK_END_DATE_IN_THE_PAST"
        ),
        CASHBACK_HAS_DATE_CONFLICT: this.$t(
          "errors.CASHBACK_HAS_DATE_CONFLICT"
        ),
        COUPON_END_DATE_IN_THE_PAST: this.$t(
          "errors.COUPON_END_DATE_IN_THE_PAST"
        ),
        CATEGORY_ALREADY_PRESENT_IN_THIS_VENDING: this.$t(
          "errors.CATEGORY_ALREADY_PRESENT_IN_THIS_VENDING"
        ),
        CELLPHONE_ALREADY_REGISTERED: this.$t(
          "errors.CELLPHONE_ALREADY_REGISTERED"
        ),
        CLIENT_ALREADY_BLOCKED: this.$t("errors.CLIENT_ALREADY_BLOCKED"),
        COULD_NOT_CREATE_STORE_CASHBACK: this.$t(
          "errors.COULD_NOT_CREATE_STORE_CASHBACK"
        ),
        COULD_NOT_DELETE_STORE_CASHBACK: this.$t(
          "errors.COULD_NOT_DELETE_STORE_CASHBACK"
        ),
        COULD_NOT_UPDATE_PROMOTION_STATUS: this.$t(
          "errors.COULD_NOT_SET_STORE_CASHBACK"
        ),
        COULD_NOT_SET_STORE_CASHBACK: this.$t(
          "errors.COULD_NOT_SET_STORE_CASHBACK"
        ),
        COULD_NOT_UPDATE_ALLOW_LIST: this.$t(
          "errors.COULD_NOT_UPDATE_ALLOW_LIST"
        ),
        COULD_NOT_UPDATE_ALLOW_LIST_ACCESS_RESTRICTION_STATUS: this.$t(
          "errors.COULD_NOT_UPDATE_ALLOW_LIST_ACCESS_RESTRICTION_STATUS"
        ),
        COULD_NOT_UPDATE_ACCESS_CONTROL_CONFIG: this.$t(
          "errors.COULD_NOT_UPDATE_ACCESS_CONTROL_CONFIG"
        ),
        COULD_NOT_UPDATE_NOTIFICATION_STATUS: this.$t(
          "errors.COULD_NOT_UPDATE_NOTIFICATION_STATUS"
        ),
        COULD_NOT_UPDATE_OPEN_DOOR_BUTTON_CONFIG: this.$t(
          "errors.COULD_NOT_UPDATE_OPEN_DOOR_BUTTON_CONFIG"
        ),
        COULD_NOT_UPDATE_SEARCH_NOT_FOUND_PRODUCTS_IN_MY_OTHER_STORES: this.$t(
          "errors.COULD_NOT_UPDATE_SEARCH_NOT_FOUND_PRODUCTS_IN_MY_OTHER_STORES"
        ),
        COULD_NOT_UPDATE_SHOW_CATALOG: this.$t(
          "errors.COULD_NOT_UPDATE_SHOW_CATALOG"
        ),
        COULD_NOT_UPDATE_SHOW_STOCK_QTY: this.$t(
          "errors.COULD_NOT_UPDATE_SHOW_STOCK_QTY"
        ),
        COULD_NOT_UPDATE_STORE_STATUS: this.$t(
          "errors.COULD_NOT_UPDATE_STORE_STATUS"
        ),
        COULD_NOT_UPDATE_VOUCHER_STATUS: this.$t(
          "errors.COULD_NOT_UPDATE_VOUCHER_STATUS"
        ),
        DELIVERY_NOT_FOUND: this.$t("errors.DELIVERY_NOT_FOUND"),
        DOOR_NOT_FOUND: this.$t("errors.DOOR_NOT_FOUND"),
        EMAIL_ALREADY_REGISTERED: this.$t("errors.EMAIL_ALREADY_REGISTERED"),
        ERROR_RESIZING_IMAGE: this.$t("errors.ERROR_RESIZING_IMAGE"),
        FILE_EXTENSION_NOT_ALLOWED_PNG_JPG_JPEG: this.$t(
          "errors.FILE_EXTENSION_NOT_ALLOWED_PNG_JPG_JPEG"
        ),
        FILE_EXTENSION_NOT_ALLOWED_XLS_XLSX: this.$t(
          "errors.FILE_EXTENSION_NOT_ALLOWED_XLS_XLSX"
        ),
        FILE_IS_TOO_LARGE_100: this.$t("errors.FILE_IS_TOO_LARGE_100"),
        FILE_IS_TOO_LARGE_150: this.$t("errors.FILE_IS_TOO_LARGE_150"),
        FILE_IS_TOO_LARGE_200: this.$t("errors.FILE_IS_TOO_LARGE_200"),
        FILE_IS_TOO_LARGE_500: this.$t("errors.FILE_IS_TOO_LARGE_500"),
        FILE_READ_ERROR: this.$t("errors.FILE_READ_ERROR"),
        IMAGE_DIMENSIONS_NOT_ALLOWED: this.$t(
          "errors.IMAGE_DIMENSIONS_NOT_ALLOWED"
        ),
        INVALID_ACCESS_DEVICE_ID: this.$t("errors.INVALID_ACCESS_DEVICE_ID"),
        INVALID_BARCODE: this.$t("errors.INVALID_BARCODE"),
        INVALID_BRAND: this.$t("errors.INVALID_BRAND"),
        INVALID_CART_PRODUCT: this.$t("errors.INVALID_CART_PRODUCT"),
        INVALID_CART_PRODUCT_ID: this.$t("errors.INVALID_CART_PRODUCT_ID"),
        INVALID_CART_PRODUCT_QUANTITY: this.$t(
          "errors.INVALID_CART_PRODUCT_QUANTITY"
        ),
        INVALID_CART_PRODUCT_PRICE: this.$t(
          "errors.INVALID_CART_PRODUCT_PRICE"
        ),
        INVALID_CASHBACK_CONFIG: this.$t("errors.INVALID_CASHBACK_CONFIG"),
        INVALID_CASHBACK_BEGIN_DATE: this.$t(
          "errors.INVALID_CASHBACK_BEGIN_DATE"
        ),
        INVALID_CASHBACK_END_DATE: this.$t("errors.INVALID_CASHBACK_END_DATE"),
        INVALID_CASHBACK_ID: this.$t("errors.INVALID_CASHBACK_ID"),
        INVALID_CASHBACK_PERCENTAGE: this.$t(
          "errors.INVALID_CASHBACK_PERCENTAGE"
        ),
        INVALID_CASHBACK_STATUS: this.$t("errors.INVALID_CASHBACK_STATUS"),
        INVALID_CATALOG_ID: this.$t("errors.INVALID_CATALOG_ID"),
        INVALID_CATEGORY: this.$t("errors.INVALID_CATEGORY"),
        INVALID_CELLPHONE: this.$t("errors.INVALID_CELLPHONE"),
        INVALID_CLIENT: this.$t("errors.INVALID_CLIENT"),
        INVALID_COMBO_DATES: this.$t("errors.INVALID_COMBO_DATES"),
        INVALID_COMBO_QUANTITY: this.$t("errors.INVALID_COMBO_QUANTITY"),
        INVALID_COMBO_STORES: this.$t("errors.INVALID_COMBO_STORES"),
        INVALID_COUNTRY_CALLING_CODE: this.$t(
          "errors.INVALID_COUNTRY_CALLING_CODE"
        ),
        INVALID_COUNTRY_CODE: this.$t("errors.INVALID_COUNTRY_CODE"),
        INVALID_COUPON_BEGIN_DATE: this.$t("errors.INVALID_COUPON_BEGIN_DATE"),
        INVALID_COUPON_END_DATE: this.$t("errors.INVALID_COUPON_END_DATE"),
        INVALID_CREDENTIALS: this.$t("errors.INVALID_CREDENTIALS"),
        INVALID_DEFAULT_VAT: this.$t("errors.INVALID_DEFAULT_VAT"),
        INVALID_DELIVERY_ID: this.$t("errors.INVALID_DELIVERY_ID"),
        INVALID_DATE: this.$t("errors.INVALID_DATE"),
        INVALID_EMAIL: this.$t("errors.INVALID_EMAIL"),
        INVALID_FEEDBACK_ID: this.$t("errors.INVALID_FEEDBACK_ID"),
        INVALID_FILTER: this.$t("errors.INVALID_FILTER"),
        INVALID_GRANT_REASON: this.$t("errors.INVALID_GRANT_REASON"),
        INVALID_HEADERS: this.$t("errors.INVALID_HEADERS"),
        INVALID_INSTALLMENTS: this.$t("errors.INVALID_INSTALLMENTS"),
        INVALID_IS_ALCOHOLIC_FLAG: this.$t("errors.INVALID_IS_ALCOHOLIC_FLAG"),
        INVALID_ITENS_PER_PURCHASE_LIMIT: this.$t(
          "errors.INVALID_ITENS_PER_PURCHASE_LIMIT"
        ),
        INVALID_NAME: this.$t("errors.INVALID_NAME"),
        INVALID_NOTIFICATION: this.$t("errors.INVALID_NOTIFICATION"),
        INVALID_OPERATOR_ID: this.$t("errors.INVALID_OPERATOR_ID"),
        INVALID_OPTION: this.$t("errors.INVALID_OPTION"),
        INVALID_ORDER_ID: this.$t("errors.INVALID_ORDER_ID"),
        INVALID_PASSWORD: this.$t("errors.INVALID_PASSWORD"),
        MERCHANT_NOT_ACCREDITED: this.$t("errors.MERCHANT_NOT_ACCREDITED"),
        TRANSACTION_ALREADY_CANCELLED: this.$t(
          "errors.TRANSACTION_ALREADY_CANCELLED"
        ),
        TRANSACTION_NOT_ELIGIBLE_FOR_CANCELLATION: this.$t(
          "errors.TRANSACTION_NOT_ELIGIBLE_FOR_CANCELLATION"
        ),
        TRANSACTION_MISSING_CANCELLATION_DATA: this.$t(
          "errors.TRANSACTION_MISSING_CANCELLATION_DATA"
        ),
        INVALID_PARTNER_NATIONAL_COMPANY_ID: this.$t(
          "errors.INVALID_PARTNER_NATIONAL_COMPANY_ID"
        ),
        INVALID_PASSWORD_RESET_TOKEN: this.$t(
          "errors.INVALID_PASSWORD_RESET_TOKEN"
        ),
        INVALID_PERCENTAGE: this.$t("errors.INVALID_PERCENTAGE"),
        INVALID_PERSON_TYPE: this.$t("errors.INVALID_PERSON_TYPE"),
        INVALID_POE: this.$t("errors.INVALID_POE"),
        INVALID_PRICE: this.$t("errors.INVALID_PRICE"),
        INVALID_QUANTITY: this.$t("errors.INVALID_QUANTITY"),
        INVALID_REQUEST: this.$t("errors.INVALID_REQUEST"),
        STORE_REQUIRED: this.$t("errors.STORE_REQUIRED"),
        BARCODE_REQUIRED: this.$t("errors.BARCODE_REQUIRED"),
        INVALID_REFILLS_OPERATIONS: this.$t(
          "errors.INVALID_REFILLS_OPERATIONS"
        ),
        NO_PRODUCT_LOGS_TO_EXPORT: this.$t("errors.NO_PRODUCT_LOGS_TO_EXPORT"),
        INVALID_SCALE_PRODUCT_SALE_TYPE: this.$t(
          "errors.INVALID_SCALE_PRODUCT_SALE_TYPE"
        ),
        INVALID_SCALE_PRODUCT_OPTION: this.$t(
          "errors.INVALID_SCALE_PRODUCT_OPTION"
        ),
        INVALID_SCALE_PRODUCT_DIGITS: this.$t(
          "errors.INVALID_SCALE_PRODUCT_DIGITS"
        ),
        INVALID_SCALE_PRODUCT_NAME: this.$t(
          "errors.INVALID_SCALE_PRODUCT_NAME"
        ),
        INVALID_SCALE_PRODUCT_CODE_LENGTH: this.$t(
          "errors.INVALID_SCALE_PRODUCT_CODE_LENGTH"
        ),
        INVALID_SCALE_PRODUCT_UNIT: this.$t(
          "errors.INVALID_SCALE_PRODUCT_UNIT"
        ),
        INVALID_SCALE_PRODUCT_CATEGORY: this.$t(
          "errors.INVALID_SCALE_PRODUCT_CATEGORY"
        ),
        INVALID_SCALE_PRODUCT_SUBCATEGORY: this.$t(
          "errors.INVALID_SCALE_PRODUCT_SUBCATEGORY"
        ),
        INVALID_SCALE_PRODUCT_IS_ALCOHOLIC: this.$t(
          "errors.INVALID_SCALE_PRODUCT_IS_ALCOHOLIC"
        ),
        INVALID_STATUS: this.$t("errors.INVALID_STATUS"),
        INVALID_STORE: this.$t("errors.INVALID_STORE"),
        INVALID_STORES_ORDER: this.$t("errors.INVALID_STORES_ORDER"),
        INVALID_SUBCATEGORY: this.$t("errors.INVALID_SUBCATEGORY"),
        INVALID_TIME_TO_BUY: this.$t("errors.INVALID_TIME_TO_BUY"),
        INVALID_TIME_TO_WARN: this.$t("errors.INVALID_TIME_TO_WARN"),
        INVALID_TIMEZONE: this.$t("errors.INVALID_TIMEZONE"),
        INVALID_TOTAL_VALUE: this.$t("errors.INVALID_TOTAL_VALUE"),
        INVALID_VENDING_ID: this.$t("errors.INVALID_VENDING_ID"),
        INVALID_USER_ID: this.$t("errors.INVALID_USER_ID"),
        INVALID_VALUE: this.$t("errors.INVALID_VALUE"),
        LOCKER_NOT_FOUND: this.$t("errors.LOCKER_NOT_FOUND"),
        MERCHANT_ALREADY_REGISTERED_WITH_THIS_EMAIL: this.$t(
          "errors.MERCHANT_ALREADY_REGISTERED_WITH_THIS_EMAIL"
        ),
        MERCHANT_NOT_FOUND: this.$t("errors.MERCHANT_NOT_FOUND"),
        MESSAGE_CANNOT_BE_EMPTY: this.$t("errors.MESSAGE_CANNOT_BE_EMPTY"),
        MISSING_PARTNER_ADDRESS_INFO: this.$t(
          "errors.MISSING_PARTNER_ADDRESS_INFO"
        ),
        MISSING_PARTNER_DRAWEE_INFO: this.$t(
          "errors.MISSING_PARTNER_DRAWEE_INFO"
        ),
        MISSING_SOURCE_CATALOG: this.$t("errors.MISSING_SOURCE_CATALOG"),
        NO_BUY_NOW_PAY_LATER_TRANSACTIONS: this.$t(
          "errors.NO_BUY_NOW_PAY_LATER_TRANSACTIONS"
        ),
        NO_CHILDREN_VENDINGS: this.$t("errors.NO_CHILDREN_VENDINGS"),
        NO_FREE_DOORS_AT_THIS_LOCKER: this.$t(
          "errors.NO_FREE_DOORS_AT_THIS_LOCKER"
        ),
        OPERATOR_NOT_FOUND: this.$t("errors.OPERATOR_NOT_FOUND"),
        PARTNER_NOT_FOUND: this.$t("errors.PARTNER_NOT_FOUND"),
        PARTNER_USER_NOT_FOUND: this.$t("errors.PARTNER_USER_NOT_FOUND"),
        PASSWORD_TOO_SHORT: this.$t("errors.PASSWORD_TOO_SHORT"),
        PASSWORDS_DONT_MATCH: this.$t("errors.PASSWORDS_DONT_MATCH"),
        PRODUCT_ALREADY_IN_CATALOG: this.$t(
          "errors.PRODUCT_ALREADY_IN_CATALOG"
        ),
        PRODUCT_ALREADY_REGISTERED: this.$t(
          "errors.PRODUCT_ALREADY_REGISTERED"
        ),
        PRODUCT_COMBO_CONFLICT: this.$t("errors.PRODUCT_COMBO_CONFLICT"),
        PRODUCT_COMBO_INTEGRATED_STORE_NOT_SUPPORTED: this.$t(
          "errors.PRODUCT_COMBO_INTEGRATED_STORE_NOT_SUPPORTED"
        ),
        PRODUCT_COMBO_NOT_FOUND: this.$t("errors.PRODUCT_COMBO_NOT_FOUND"),
        PRODUCT_NOT_FOUND: this.$t("errors.PRODUCT_NOT_FOUND"),
        PRODUCT_NOT_FOUND_IN_STORE: this.$t(
          "errors.PRODUCT_NOT_FOUND_IN_STORE"
        ),
        REASON_CANNOT_BE_EMPTY: this.$t("errors.REASON_CANNOT_BE_EMPTY"),
        REACHED_MAX_VENDING_CATEGORY_QTY: this.$t(
          "errors.REACHED_MAX_VENDING_CATEGORY_QTY"
        ),
        REJECTED_PRODUCT: this.$t("errors.REJECTED_PRODUCT"),
        SCALE_PRODUCT_CODE_ALREADY_EXISTS: this.$t(
          "errors.SCALE_PRODUCT_CODE_ALREADY_EXISTS"
        ),
        SCALE_PRODUCT_CODE_NOT_FOUND: this.$t(
          "errors.SCALE_PRODUCT_CODE_NOT_FOUND"
        ),
        SEMAPHORE_RED: this.$t("errors.SEMAPHORE_RED"),
        STORE_NOT_FOUND: this.$t("errors.STORE_NOT_FOUND"),
        TOO_MANY_LOGIN_ATTEMPTS: this.$t("errors.TOO_MANY_LOGIN_ATTEMPTS"),
        TRANSACTION_LOCKED: this.$t("errors.TRANSACTION_LOCKED"),
        TRANSACTION_NOT_FOUND: this.$t("errors.TRANSACTION_NOT_FOUND"),
        USER_CANNOT_BE_BLOCKED: this.$t("errors.USER_CANNOT_BE_BLOCKED"),
        USER_NOT_FOUND: this.$t("errors.USER_NOT_FOUND"),
        UNEXPECTED_ERROR: this.$t("errors.UNEXPECTED_ERROR"),
        VENDING_AC_DEVICE_NOT_ACTIVE: this.$t(
          "errors.VENDING_AC_DEVICE_NOT_ACTIVE"
        ),
        VENDING_AC_DEVICE_NOT_FOUND: this.$t(
          "errors.VENDING_AC_DEVICE_NOT_FOUND"
        ),
        VENDING_AC_DEVICE_PROVIDER_NOT_FOUND: this.$t(
          "errors.VENDING_AC_DEVICE_PROVIDER_NOT_FOUND"
        ),
        VENDING_CATEGORY_NOT_FOUND: this.$t(
          "errors.VENDING_CATEGORY_NOT_FOUND"
        ),
        VENDING_DID_NOT_RESPOND: this.$t("errors.VENDING_DID_NOT_RESPOND"),
        VENDING_NOT_FOUND: this.$t("errors.VENDING_NOT_FOUND"),
        VENDING_SOCKET_ID_NOT_FOUND: this.$t(
          "errors.VENDING_SOCKET_ID_NOT_FOUND"
        ),
        WRONG_PASSWORD: this.$t("errors.WRONG_PASSWORD"),
        TOTEM_DID_NOT_RESPOND: this.$t("errors.TOTEM_DID_NOT_RESPOND")
      };
      return translations[message] || this.$t("errors.UNEXPECTED_ERROR");
    }
  }
};

export { common };
